import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import ExpertWitness from "./pages/ExpertWitness";
import Team from "./pages/Team";
import About from "./pages/About";
import Contact from "./pages/Contact";
import WorkWithUs from "./pages/WorkWithUs";
import FAQ from "./pages/FAQ";
import ProjectsIndex from "./pages/ProjectsIndex";
import ProjectDetail from "./pages/ProjectDetail";
import NorthTampaCustomHome from "./pages/NorthTampaCustomHome";
import Construction from "./pages/Construction";
import FederalServices from "./pages/FederalServices";
import DisasterRecovery from "./pages/DisasterRecovery";
import Federal from "./pages/Federal";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminPanel from "./pages/admin/AdminPanel";
import { LocalBusinessSchema } from "./components/SEO";
import ErrorBoundary from "./components/ErrorBoundary";
import ScrollToTop from "./components/ScrollToTop";
import Redirect from "./components/Redirect";
import BackToTop from "./components/BackToTop";
import Breadcrumbs from "./components/Breadcrumbs";
import { api } from "./lib/api";

function App() {
  useEffect(() => {
    const token = localStorage.getItem("bcp_token");
    if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }, []);

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <div className="App">
          <LocalBusinessSchema />
          <BrowserRouter>
            <ScrollToTop />
            <Breadcrumbs />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/construction" element={<Construction />} />
              <Route path="/federal-services" element={<FederalServices />} />

              {/* Construction */}
              <Route path="/custom-homes" element={<ServicePage slug="custom-homes" />} />
              <Route path="/renovations" element={<ServicePage slug="renovations" />} />
              <Route path="/kitchen-and-bath" element={<ServicePage slug="kitchen-and-bath" />} />
              <Route path="/commercial-construction" element={<ServicePage slug="commercial-construction" />} />

              {/* Recovery & Federal */}
              <Route path="/disaster-recovery" element={<DisasterRecovery />} />
              <Route path="/federal" element={<Federal />} />
              <Route path="/expert-witness" element={<ExpertWitness />} />

              {/* Old PDF URLs, deleted; redirect to current pages */}
              <Route path="/preview/carpenter_cv.pdf" element={<Redirect to="/expert-witness" />} />
              <Route path="/preview/bcpeabody_capability_statement.pdf" element={<Redirect to="/federal" />} />

              {/* Old slug redirects (301 via client-side replace) */}
              <Route path="/consulting" element={<Redirect to="/disaster-recovery" />} />
              <Route path="/careers" element={<Redirect to="/work-with-us" />} />
              <Route path="/blog" element={<Redirect to="/" />} />
              <Route path="/blog/*" element={<Redirect to="/" />} />
              <Route path="/projects/3144-west-waverly-park" element={<Redirect to="/projects/waverly-park-kitchen" />} />
              <Route path="/projects/west-palm-beach-va-main-lobby-renovation" element={<Redirect to="/projects/tampa-va-front-lobby-renovation" />} />

              {/* Content */}
              <Route path="/team" element={<Team />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<ProjectsIndex />} />
              <Route path="/projects/north-tampa-custom-home" element={<NorthTampaCustomHome />} />
              <Route path="/projects/:slug" element={<ProjectDetail />} />
              <Route path="/work-with-us" element={<WorkWithUs />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />

              {/* Legal */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<AdminPanel />} />
            </Routes>
            <BackToTop />
          </BrowserRouter>
        </div>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
